import React, { useEffect, useState, forwardRef } from 'react';
import styled, { keyframes, Keyframes } from 'styled-components'


import { createRoomMovement } from '../utils/roomHelpers'

const Room = forwardRef<HTMLDivElement, any>(({children},ref) => {
	const [BrowserSupport, setBrowserSupport] = useState(true);

  useEffect(() => {
    const checkBrowser = () => {
      var isFirefox = typeof InstallTrigger !== 'undefined';
      if(isFirefox){setBrowserSupport(false)};
    }

    checkBrowser();
  }, [])

	return(
		<StyledRoom ref={ref} className={!BrowserSupport ? "browserFix" : ""}>{children}</StyledRoom>
	)
})

export default Room;

const StyledRoom = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  transform-style: preserve-3d;
  pointer-events: auto;

  &.browserFix{
    position:relative;
    height:100%;
  }
`